import React, { useState, useEffect } from 'react';
import { PageSettings } from './config/page-settings.js';
import { useLocation, useHistory } from 'react-router-dom';

import Header from './components/header/header.js';
import Sidebar from './components/sidebar/sidebar.js';
import Content from './components/content/content.js';
import { useSSO } from './pages/login/ssoHook';
import AnnouncementViewModal from './pages/announcement/AnnouncementViewModal.js';
import { RouteKey } from './config/page-key.js';
import { Layout, Skeleton } from 'antd';
import { useUserKey } from './features/user/ssoSlice.js';
import { useDismissAnnouncementMutation, useGetUserAnnouncementsQuery } from './features/announcement/AnnouncementApi.js';

export const App = () => {
	const location = useLocation();
	const [pageHeader, setPageHeader] = useState(true);
	const [pageSidebar, setPageSidebar] = useState(true);
	const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
	const [dismissAnnouncement] = useDismissAnnouncementMutation();
	const userKey = useUserKey();
	const { data: announcements, isFetching } = useGetUserAnnouncementsQuery(undefined, { skip: !userKey, refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    refetchOnReconnect: false, });

	useSSO();

	useEffect(() => {
		setPageHeader(location.pathname !== RouteKey.LOGIN && location.pathname !== RouteKey.SSO)
		setPageSidebar(location.pathname !== RouteKey.LOGIN && location.pathname !== RouteKey.SSO)
	}, [location.pathname]);

	const handleSetPageSidebar = (value) => {
		setPageSidebar(value);
	}

	const handleSetPageHeader = (value) => {
		setPageHeader(value)
	}

	useEffect(() => {
		if (isFetching) return;
		if (announcements && announcements.length > 0) {
			setShowAnnouncementModal(true);
		}
	}, [userKey, isFetching, announcements]);

	return (
		<>
			<PageSettings.Provider value={{
				pageHeader,
				pageSidebar,
				handleSetPageHeader,
				handleSetPageSidebar
			}}>
				<Layout style={{ minHeight: "100vh", background: "#fff" }}>
					{pageSidebar && (<Sidebar />)}
					<Layout style={{ background: "#fff" }}>
						{pageHeader && (<Header />)}
						<Content />
					</Layout>
				</Layout>
			</PageSettings.Provider>
			<AnnouncementViewModal
				announcementDetails={announcements}
				preview={false}
				isModalOpen={showAnnouncementModal}
				onClose={(e) => {
					setShowAnnouncementModal(false);

					const promiseArray = [];
					let promiseDelay = 10;

					Object.keys(e).map(i => {
						promiseArray.push(
							new Promise(resolve =>
								setTimeout(
									() => resolve(dismissAnnouncement({ id: i })),
									promiseDelay
								)
							)
						);
					})

					Promise.all(promiseArray)
						.then(async () => {
							//do nothing
						})
						.catch(err => {
							//do nothing first
						})
				}}
			/>
		</>
	)
}

export default App;